<!--
 * @FilePath: /src/views/join.vue
 * @Description: 加入我们
-->

<template>
  <div>
    <header-view @same-router="sameRouter"></header-view>
    <div id="content" class="content-box">
      <div class="content-banner"></div>
      <div class="table-content">
        <div class="table-box f-cb">
          <div id="join">
            <ul id="join_toggle" class="nav f-fl">
              <li class="title">
                <h2>加入传发</h2>
                <span class="tip"> JOIN US</span>
              </li>
              <li @click="handlChangeTab('post')" :class="{'active': item === 'post'}">岗位需求</li>
              <li @click="handlChangeTab('weal')" :class="{'active': item === 'weal'}">福利待遇</li>
              <li @click="handlChangeTab('shine')" :class="{'active': item === 'shine'}">员工风采</li>
            </ul>

            <div id="join_container">

              <div v-if="item === 'post'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">岗位需求</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 加入传发 > <span>岗位需求</span>
                  </span>
                </div>
                <div id="addressToggle" class="addressTable f-cb">
                  <div @click="handleChangePost('nc')" :class="{'active': post === 'nc'}" class="f-fl">南昌职场</div>
                  <div @click="handleChangePost('sh')" :class="{'active': post === 'sh'}" class="f-fr">上海职场</div>
                </div>
                <div id="address_box" class="address-box">
                  <div v-if="post === 'nc'" class="con">
                    <h3 class="tip">储备干部</h3>
                    <div class="text">
                      <p class="title">职位描述：</p>
                      <p>
                        1.作为客户服务后备主管和技能专家进行培养，通过专业人才培养体系，未来可胜任客户服务团队管理工作；
                      </p>
                      <p>
                        2.负责公司客户服务工作的开展与实施，客户反馈问题的沟通和处理，协助与指导客户，提供有效的解决方案。
                      </p>
                      <p class="top title">任职要求：</p>
                      <p>1.大专及以上学历；</p>
                      <p>2.意愿加入金融行业，熟练操作电脑；</p>
                      <p>
                        3.具备良好的沟通和学习能力，好学上进，有一定的管理培养潜力；
                      </p>
                      <p>
                        4.有极高的专业追求，愿意在不断接受挑战中成长，综合素质较好有一定的专业潜力。
                      </p>
                      <p class="top title">
                        招聘人数： 200人 （实习生、应届生）
                      </p>
                      <p class="title">工作地点：南昌-红谷滩新区</p>
                      <p class="email top">
                        有意向请发送简历到：zhongling.hu@cf-fis.com
                        &nbsp;&nbsp;&nbsp;&nbsp; 请下载
                        <a href="https://a1.xystatic.com/page/release/cfjr/latest/简历模板.xls">简历模板</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item === 'weal'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">福利待遇</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 加入传发 > <span>福利待遇</span>
                  </span>
                </div>
                <div class="con">
                  <h3 class="title">极具优势的薪资福利体系</h3>
                  <img src="../assets/images/c1.png" alt="" />

                  <div class="join">
                    <p class="light">
                      综合薪资：平均起薪6000+ 绩优人员薪资10,000+
                    </p>
                    <p>实习薪酬=基本工资+高额绩效奖金；</p>
                    <p>
                      转正薪酬=基本工资+岗位津贴+高额绩效奖金+优质福利(中餐补贴、节庆福利、带薪年假)
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="item === 'shine'" class="content f-fr">
                <div class="title f-cb">
                  <h3 class="f-fl">员工风采</h3>
                  <span class="des f-fr">
                    您的位置：首页 > 加入传发 > <span>员工风采</span>
                  </span>
                </div>
                <div class="con">
                  <img class="top" src="../assets/images/c2.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
import HeaderView from '@/components/header.vue'
import FooterView from '@/components/footer.vue'

export default {
  name: 'joiView',
  data() {
    return {
      item: 'post',
      post: 'nc'
    }
  },
  created() {
    this.item = this.$route.params.item || 'post'
    this.post = 'nc'
  },
  methods: {
    handlChangeTab(tab) {
      this.item = tab
    },
    handleChangePost(post) {
      this.post = post
    },
    sameRouter(params) {
      this.handlChangeTab(params.item)
      this.post = 'nc'
    }
  },
  components: {
    HeaderView,
    FooterView
  }
}
</script>
<style lang="stylus">
color = #f37a55;

.content-box {
  .content-banner {
    width: 100%;
    height: 290px;
    background: url('../assets/images/banner2.png') no-repeat;
    background-size: cover;
    background-position: center;
  }

  .table-content {
    width: 100%;
    padding-bottom: 130px;

    .table-box {
      width: 1200px;
      margin: 0px auto;
      margin-top: -34px;
    }
  }
}

.table-box {
  .nav {
    width: 234px;

    .title {
      h2 {
        margin: 10px 0;
      }

      width: 100%;
      height: 122px;
      font-size: 22px;
      color: white;
      background-color: color;
      padding: 26px;

      .tip {
        color: #f8a084;
      }
    }

    .active {
      border-left: 2px solid color;
      background-color: #f3f3f3;
    }

    li+li {
      cursor: pointer;
      position: relative;
      line-height: 32px;
      height: 64px;
      border-left: 1px solid #d5d5d5;
      border-right: 1px solid #d5d5d5;
      border-bottom: 1px solid #d5d5d5;
      padding: 16px;

      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-top: 6px solid #d5d5d5;
        border-left: 6px solid transparent;
        right: 10px;
        top: 50%;
        transform: rotate(45deg) translateY(-50%);
      }
    }
  }

  .hide {
    display: none;
  }

  .content {
    width: 947px;
    padding: 1px 42px 70px;
    background-color: white;
    border: 1px solid #d5d5d5;

    .contact-us {
      height: 314px;
      padding-top: 20px;

      .contact-us-title {
        text-align: center;
        padding-top: 35px;

        span {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #464647;
          line-height: 30px;
          margin-left: 16px;
          vertical-align: bottom;
        }
      }

      .contact-us-1 {
        vertical-align: top;
        margin-right: 28px;
      }

      .contact-us-module {
        width: 414px;
        height: 295px;
        background: #f8f8f8;
        box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
        display: inline-block;

        .contact-us-content {
          padding: 28px 40px 52px 40px;

          p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #464647;
            line-height: 32px;
          }
        }

        .contact-us-line {
          width: 372px;
          height: 1px;
          border: 1px solid #dfdfdf;
          margin: 0 auto;
          margin-top: 24px;
        }
      }
    }

    >.title {
      padding: 22px 0;
      height: 64px;
      border-bottom: 1px solid #d5d5d5;

      h3 {
        font-size: 18px;
        font-weight: normal;
        padding-left: 10px;
        height: 20px;
        line-height: 20px;
        width: 200px;
        color: #bdbcbd;
        border-left: 8px solid color;
      }

      .des {
        color: #c0c0c0;

        span {
          color: #D45A1A;
        }
      }
    }

    .addressTable {
      margin: 30px auto 40px;
      width: 846px;
      height: 50px;
      position: relative;

      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 10px;
        height: 1px;
        top: 49px;
        left: 418px;
        background-color: #e1e1e1;
      }

      >.active {
        background-color: white;
        border-bottom: none;
      }

      >div {
        background-color: #f9f9f9;
        font-size: 18px;
        border: 1px solid #e1e1e1;
        width: 418px;
        height: 100%;
        line-height: 46px;
        text-align: center;
        background-color: #f4f4f4;
      }
    }

    .address-box {
      padding: 0px 5px;

      >div {
        display: block;
      }

      >.show {
        display: block;
      }
    }

    .con {
      line-height: 26px;

      >.title {
        color: #676767;
        text-align: center;
        font-size: 16px;
        margin: 65px auto 35px;
      }

      .indent {
        text-indent: 30px;
      }

      .top {
        margin-top: 20px;
      }

      .tip {
        margin-top: 40px;
        background-color: #f2f2f4;
        padding: 6px 10px;
      }

      .light {
        color: color;
        font-size: 16px;
        margin: 16px 0;
      }

      img {
        max-width: 100%;
        display: block;
        margin: 0 auto;
      }

      .shanghai {
        border: 2px solid #665a56;
      }

      .join {
        margin: 40px 150px;
      }

      .address {
        width: 700px;
        margin: 20px auto;
        line-height: 26px;

        .d2 {
          margin-top: 20px;
        }

        >div {
          width: 100%;

          .p1 {
            width: 84px;
          }

          .p2 {
            margin-left: 84px;
          }
        }
      }

      .text {
        color: #8a8a8a;
        margin: 20px 12px;
        line-height: 26px;

        >.title {
          color: #676767;
          font-size: 16px;
        }

        .email {
          color: #555559;
          font-size: 16px;
          font-weight: bold;

          a {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/join.vue